exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  padding: 2rem; }\n  :host #header {\n    margin: 2rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/notifications/notifications.component.scss
// module id = ../../../../../src/app/notifications/notifications.component.scss
// module chunks = main